import React from "react";
import { useSelector } from "react-redux";

import ListingDetailsHeader from "../../details/ListingDetailsHeader";

import ListingPreviewTable from "./ListingPreviewTable";

import s from "./ListingDetailsPreview.module.scss";

export default function ListingDetailsPreview({ product, goBack }) {
	const market = useSelector((state) => state.market || {});
	const user = market.user || {};

	// ------------------------------------- DATA -------------------------------------

	return (
		<div className={s.root}>
			<ListingDetailsHeader product={product} user={user} goBack={goBack} />

			<div className={s.pageContent}>
				<ListingPreviewTable product={product} />
			</div>
		</div>
	);
}
